(function () {
    try {
      /* main variables */
      var debug = 0;
      var variation_name = "";
      var $;
      
      /* all Pure helper functions */
      function waitForElement(selector, trigger, delayInterval, delayTimeout) {
        var interval = setInterval(function () {
          if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
          ) {
            clearInterval(interval);
            trigger();
          }
        }, delayInterval);
        setTimeout(function () {
          clearInterval(interval);
        }, delayTimeout);
      }
  
      conditionSection=
        `<section id="eg-nail-care-section">
          <h2>Arrêtez de lutter contre les problèmes d’ongles persistants</h2>
          <p>Recommandé pour soulager les symptômes de plusieurs affections des ongles difficiles à traiter et résistantes</p>
          <div class="eg-nail-care-container">
            <table class="eg-nail-care-table">
              <thead>
                <tr>
                  <th>Problème d’ongles</th>
                  <th>Comment le Stylo Soin des Ongles aide</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Ongles décolorés</td>
                  <td>Redonne un éclat sain aux ongles</td>
                </tr>
                <tr>
                  <td>Taches blanches</td>
                  <td>Aide à obtenir des ongles clairs et sans taches</td>
                </tr>
                <tr>
                  <td>Ongles jaunes</td>
                  <td>Restaure la couleur naturelle et lumineuse des ongles</td>
                </tr>
                <tr>
                  <td>Ongles fissurés ou cassants</td>
                  <td>Renforce et protège les ongles fragiles</td>
                </tr>
                <tr>
                  <td>Ongles faibles</td>
                  <td>Améliore la résistance et la flexibilité pour éviter la casse</td>
                </tr>
                <tr>
                  <td>Stries </td>
                  <td>Lisse les stries visibles</td>
                </tr>
                <tr>
                  <td>Marques sur les ongles</td>
                  <td> Restaure un ton uniforme et sain</td>
                </tr>
                <tr>
                  <td>Ongles décollés</td>
                  <td>Renforce les ongles lâches</td>
                </tr>
                <tr>
                  <td>Ongles enfoncés</td>
                  <td>Aide à réparer les surfaces irrégulières pour un aspect soigné</td>
                </tr>
                <tr>
                  <td>Ongles des pieds épais</td>
                  <td>Réduit l’épaisseur pour un découpage plus facile</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button id="eg-scroll-cta" class="eg-cta-btn">Koop nu gezondere nagels</button>
        </section>`;
  
      function init() {
        document.body.classList.add('AB005');
        const bundleSection=document.querySelector('#__pf [data-pf-type="Section"]>div:first-child');
        if(bundleSection &&!document.querySelector('#eg-nail-care-section')){
          bundleSection.insertAdjacentHTML('afterend', conditionSection);
        }
  
        document.getElementById("eg-scroll-cta").addEventListener("click", function () {
          const targetSection = document.querySelector('#__pf [data-pf-type="Section"]>div:first-child .pf-product-form>div:nth-of-type(3)');
          if (targetSection) {
            targetSection.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
  
      /* Initialize variation */
      if (window.location.pathname === '/products/stylo-de-soin-des-ongles') {
          waitForElement('#__pf [data-pf-type="Section"]>div:first-child', init, 50, 15000);
      }
    } catch (e) {
      if (debug) console.log(e, "error in Test" + variation_name);
    }
  })();